"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var KeepStateBuilder_1 = require("./KeepStateBuilder");
exports.KeepStateBuilder = KeepStateBuilder_1.default;
var NextStateBuilder_1 = require("./NextStateBuilder");
exports.NextStateBuilder = NextStateBuilder_1.default;
var RepeatStateBuilder_1 = require("./RepeatStateBuilder");
var ResultBuilder_1 = require("./ResultBuilder");
exports.default = ResultBuilder_1.default;
/**
 * Returns a {@link NextStateBuilder}
 * @param state
 * @return {NextStateBuilder}
 */
function nextState(state) {
    return new NextStateBuilder_1.default(state);
}
exports.nextState = nextState;
/**
 * Returns a {@link KeepStateBuilder}
 * @return {KeepStateBuilder}
 */
function keepState() {
    return new KeepStateBuilder_1.default();
}
exports.keepState = keepState;
/**
 * Returns a {@link RepeatStateBuilder}
 * @return {RepeatStateBuilder}
 */
function repeatState() {
    return new RepeatStateBuilder_1.default();
}
exports.repeatState = repeatState;
/**
 * Helper function to return a reply
 * @param from
 * @param msg
 * @return {ResultBuilder}
 */
function reply(from, msg) {
    return new KeepStateBuilder_1.default().reply(from, msg);
}
exports.reply = reply;
/**
 * Helper function to insert a new event
 * @param type
 * @param context
 * @param extra
 * @return {ResultBuilder}
 */
function nextEvent(type, context, extra) {
    return new KeepStateBuilder_1.default().internalEvent(context, extra);
}
exports.nextEvent = nextEvent;
/**
 * Helper function to insert an 'internal' event
 * @param {EventContext} context
 * @param {EventExtra} extra
 * @return {KeepStateBuilder}
 */
function internalEvent(context, extra) {
    return new KeepStateBuilder_1.default().internalEvent(context, extra);
}
exports.internalEvent = internalEvent;
/**
 * Helper function to set a state timeout (keeps state and data)
 * @param time
 * @return {ResultBuilder}
 */
function stateTimeout(time) {
    return new KeepStateBuilder_1.default().stateTimeout(time);
}
exports.stateTimeout = stateTimeout;
/**
 * Helper function to set the event timeout timer
 * @param time
 * @return {ResultBuilder}
 */
function eventTimeout(time) {
    return new KeepStateBuilder_1.default().eventTimeout(time);
}
exports.eventTimeout = eventTimeout;
/**
 * helper function to set a generic timer
 * @param time
 * @return {ResultBuilder}
 */
function timeout(time) {
    return new KeepStateBuilder_1.default().timeout(time);
}
exports.timeout = timeout;
/**
 * Helper to only mutate data
 * @param spec
 * @return {ResultBuilder}
 */
function data(spec) {
    return new KeepStateBuilder_1.default().data(spec);
}
exports.data = data;
//# sourceMappingURL=index.js.map